import IContentDialogService from "./IContentDialogService";
import { store } from 'infrastructure/store/ConfigureStore';
import { ContentDialogActionTypes } from "infrastructure/store/contentDialog/ContentDialogActionTypes";
import { injectable } from "inversify";
import { inversifyContainer } from "infrastructure/ioc/ioc.container";
import IRepository from "data/IRepository";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import ContentDialogRequest from "./ContentDialogRequest";
import { trackPromise } from "react-promise-tracker";

@injectable()
export default class ContentDialogService implements IContentDialogService {

  openDialog(title: string, renderContent: () => JSX.Element, closable: boolean = true, animated: boolean = true): void {
    store.dispatch({
      type: ContentDialogActionTypes.SET_CONTENT_DIALOG,
      data: {
        showDialog: true,
        title: title,
        renderContent: renderContent,
        closable: closable,
        animated: animated
      },
    });
  }

  async openDialogAsync<T extends object>(dialogRequest: ContentDialogRequest<T>): Promise<void> {
    const repository = inversifyContainer.get<IRepository<T>>(IocTypes.Repository);
    let result:T = {} as T;

    // default usage is with tracking promise (= loading spinner)
    if (dialogRequest.useTrackPromise === undefined || dialogRequest.useTrackPromise === true) {
      result = await trackPromise(repository.getOne(dialogRequest.request), dialogRequest.trackPromiseArea);
    } else {
      result = await repository.getOne(dialogRequest.request);
    }

    if (Object.keys(result).length !== 0) {
      let renderContentCallback = () => dialogRequest.renderContent(result);

      store.dispatch({
        type: ContentDialogActionTypes.SET_CONTENT_DIALOG,
        data: {
          showDialog: true,
          title: dialogRequest.title,
          renderContent: renderContentCallback
        },
      });
    }
  }

  closeDialog(): void {
    store.dispatch({
      type: ContentDialogActionTypes.SET_CONTENT_DIALOG,
      data: {
        showDialog: false,
        title: "",
        renderContent: undefined,
        closable: true
      },
    });
  }
}